var exports = {
  "aO": "xf0b3b88a--3a057b--agent_name",
  "if": "xf0b3b88a--3a057b--honest_work",
  "tV": "xf0b3b88a--3a057b--rate_small",
  "RJ": "xf0b3b88a--3a057b--reviews_info",
  "qo": "xf0b3b88a--3a057b--no_reviews",
  "DG": "xf0b3b88a--3a057b--rate_container",
  "oG": "xf0b3b88a--3a057b--statistics",
  "nK": "xf0b3b88a--3a057b--stats_param-value--green",
  "n1": "xf0b3b88a--3a057b--circle",
};

module.exports = exports;
